import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

/**
 * @component TableSelectionModal
 * @description
 * A modal component that allows users to select multiple tables for their order.
 * Displays a list of tables and lets users choose by clicking on them.
 * On save, updates the `custDetails` object with the selected tables.
 *
 * @props
 * @param {function} onHide - Function to close the modal.
 * @param {boolean} show - Boolean to control modal visibility.
 * @param {object} custDetails - The current customer details object.
 * @param {function} setCustDetails - Function to update customer details.
 * @param {array} selectedTables - Array of currently selected table IDs.
 * @param {function} setSelectedTables - Function to update selected tables.
 *
 * @returns {JSX.Element} - The rendered modal for table selection.
 */
function TableSelectionModal({ onHide, show, custDetails, setCustDetails, selectedTables, setSelectedTables }) {

  //Setting table numbers with chairs
  const tables = Array.from({ length: 7 }, (_, index) => ({
    id: index + 1,
    seats: 2,
  }));


  //Handling table popup
  const handleTableClick = (tableId) => {
    // Toggle selection
    if (selectedTables.includes(tableId)) {
      setSelectedTables(selectedTables.filter((id) => id !== tableId));
    } else {
      setSelectedTables([...selectedTables, tableId]);
    }
  };

  //Handler function for saving/updating selected tables
  const handleSaveSelection = () => {
    setCustDetails({
      ...custDetails,
      tableNumber: selectedTables.join(','),
    });
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="d-flex flex-wrap justify-content-center">
          {tables.map((table) => (
            <div
              key={table.id}
              style={{
                border: selectedTables.includes(table.id)
                  ? '2px solid blue'
                  : '2px solid green',
                borderRadius: '10px',
                cursor: 'pointer',
                backgroundColor: selectedTables.includes(table.id)
                  ? '#cce5ff'
                  : 'transparent',
              }}
              className="d-flex flex-column text-center p-3 m-3"
              onClick={() => handleTableClick(table.id)}
            >
              <span>Table {table.id}</span>
              <span>Seats: {table.seats}</span>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSaveSelection}>
          Save Selection
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TableSelectionModal;
